import { Table } from '../../../../components/general/table';
import { useSurveyResponseList } from './hook';
import { SurveyResponseListProps } from './props';

export const SurveyResponseList = ({ filters }: SurveyResponseListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useSurveyResponseList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[10, 20, 50, 100]}
            autoAdjustHeight
            disableRowSelectionOnClick
        />
    );
};
